import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import CTASection from "@/components/CTASection";
import { Reveal, Overline } from "@/components/Reveal";
import { IMAGES, SERVICES } from "@/lib/site";

export default function ServicesPage() {
  return (
    <main data-testid="services-page">
      <SEO
        title="Our Services — Custom Cabinets, Kitchen & Bathroom Renovations GTA | Hive Interiors"
        description="Custom kitchen cabinets, kitchen renovations, bathroom renovations, cabinet refacing, home interior renovations and custom interior solutions across the GTA."
      />
      <PageHero
        image={IMAGES.servicesHero}
        overline="What We Do"
        title="Design-Led Services,"
        italic="Built to Last"
        sub="From a single set of custom cabinets to a complete home transformation, every Hive Interiors project is designed, crafted, and installed with the same attention to detail."
        alt="Modern home interior renovation by Hive Interiors"
      />
      <section className="py-24 md:py-36">
        <div className="max-w-7xl mx-auto px-6 md:px-12 space-y-20 md:space-y-28">
          {SERVICES.map((s, i) => (
            <Reveal key={s.num}>
              <div
                data-testid={`services-detail-${s.num}`}
                className={`grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 items-center ${
                  i % 2 === 1 ? "md:[&>*:first-child]:order-2" : ""
                }`}
              >
                <div className="md:col-span-7 group overflow-hidden relative">
                  <img
                    src={s.img}
                    alt={s.alt}
                    loading="lazy"
                    className="w-full aspect-[16/10] object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                  />
                  <span className="absolute top-5 left-5 font-heading italic text-6xl text-white/90 drop-shadow-lg">
                    {s.num}
                  </span>
                </div>
                <div className="md:col-span-5">
                  <Overline>Service {s.num}</Overline>
                  <h2 className="mt-4 font-heading text-3xl md:text-5xl tracking-tight leading-[1.1]">
                    {s.title}
                  </h2>
                  <p className="mt-6 text-base text-muted-foreground leading-relaxed">{s.desc}</p>
                  <Link
                    to={s.href}
                    data-testid={`services-detail-link-${s.num}`}
                    className="mt-8 inline-flex items-center gap-3 text-xs uppercase tracking-[0.2em] font-bold text-primary group"
                  >
                    Explore
                    <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
                  </Link>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
      <CTASection />
    </main>
  );
}
